<template>
  <div class="section section--slide featured-projects"
			 :class="`section--${shadeMode} splide--${shadeMode}`"
			v-if="content.projects !== null">
    <h2 v-if="projectsHeading !== null" class="section__heading featured-project__heading">{{projectsHeading}}</h2>
    <splide :options="projectOptions">
      <splide-slide v-for="project in content.projects" :key="project.title.en">
        <nuxt-link class="featured-project"
									 :to="localePath(`/projects/${project.slug.current}`)">
          <img v-if="project.projectHero.asset.url !== null && project.projectHeroAlt !== null"
									 :src="$urlFor(project.projectHero.asset.url, 800)"
									 :alt="lang === 'en' ? project.projectHeroAlt.en || project.title.en + ' image' : project.projectHeroAlt.jp || project.title.jp + ' image'"
									 class="featured-project__image"
									 loading="lazy"
									 :height="project.projectHero.asset.metadata.dimensions.height"
									 :width="project.projectHero.asset.metadata.dimensions.width" />
          <div class="featured-project__details">
            <h5 class="featured-project__type" v-if="project.projectType !== null">{{ locale === 'en' ? project.projectType.en : project.projectType.jp }}</h5>
            <h3 class="featured-project__title" v-if="project.title !== null">{{ locale === 'en' ? project.title.en : project.title.jp }}</h3>
          </div>
        </nuxt-link>
      </splide-slide>
    </splide>
    <NuxtLink :to="localePath(`/projects?type=${content.linkType || 'all'}`)"
							class="block-link block-link--projects">
			{{projectsLinkText}} &rarr;
		</NuxtLink>
  </div>
</template>

<script setup>
import { Splide, SplideSlide } from '@splidejs/vue-splide'
import '@splidejs/splide/dist/css/themes/splide-default.min.css'
import { useI18n, useLocalePath } from '#imports'
import { computed } from "vue"
const { locale } = useI18n()
const localePath = useLocalePath()
const props = defineProps({
  content: Object
})
const lang = useState('jp')
let shadeMode = props.content.isDarkMode === true ? 'dark' : 'light'
const projectOptions = {
  rewind : false,
  drag: 'free',
  perMove: '1',
  perPage: '1',
  autoWidth: true,
  width  : '100%',
  gap    : '1rem',
  snap    : true,
  lazyLoad: true,
  pagination: false
}
let projectsHeading
let projectsLinkText
if(props.content.title !== null) {
  projectsHeading = computed(() => locale.value === 'en' ? props.content.title.en : props.content.title.jp)
} else {
	projectsHeading = computed(() => locale.value === 'en' ? 'Related Projects' : '関連プロジェクト')
}
if(props.content.projectsLinkText !== null) {
	projectsLinkText = computed(() => locale.value === 'en' ? props.content.projectsLinkText.en : props.content.projectsLinkText.jp )
} else {
	projectsLinkText = computed(() => locale.value === 'en' ? 'See all of our projects' : 'すべてのプロジェクトをご覧')
}
</script>

<style lang="scss">
@use '@/assets/sass/variables.scss' as v;
.featured-projects {
  margin: 0;
  max-width: 100%;
  padding: 1rem 0 1rem 1rem;
  position: relative;
  @include v.respond-to('small') {
    margin: 0;
    padding: 3rem 0 3rem 3rem;
  }
}
.splide__list {
  margin: 0 1rem 0 0 !important;
}
.featured-project {
  background-color: transparent;
  display: block;
  margin: 0;
  min-width: 18rem;
  max-width: 85vw;
  text-decoration: none;
  transition: 0.3s;
  @include v.respond-to('small') {
    margin: 0;
    max-width: 30rem;
  }
  &:hover {
    background-color: v.$teal;
    color: v.$white;
    transition: 0.3s;
  }
  &__heading {
		margin: 0 0 1rem 0;
		max-width: 18rem;
    padding: 0;
    @include v.respond-to('small') {
			margin: 0 0 2rem 0;
      max-width: 90vw;
    }
  }
  &__image {
    height: 13.5rem;
    object-fit: cover;
    width: 100%;
    @include v.respond-to('small') {
      height: 17rem;
    }
  }
  &__details {
		height: 6rem;
    padding: 0 0 0.5rem 0.5rem;
		@include v.respond-to('small') {
			padding: 0 0.5rem 0.5rem 0.5rem;
		}
  }
  &__type {
    font-size: v.$font-size;
		font-weight: 500;
    margin: 0;
    padding: 0.25rem 0;
		@include v.respond-to('small') {
			padding: 0.25rem 0.5rem;
		}
  }
  &__title {
		font-family: var(--font);
    font-size: v.$font-size-med;
    margin: 0;
    padding: 0;
		@include v.respond-to('small') {
			padding: 0 0 0 0.5rem;
		}
  }
}
</style>
